/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { reposGet } from "../../funcs/reposGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetRepoRequest$inboundSchema,
};

export const tool$reposGet: ToolDefinition<typeof args> = {
  name: "repos-get",
  description: `Get a repository

Reads a single repository after the org+role access check (org
owner/admin of the repository's org only).
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await reposGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
